import { Chain } from 'viem'
import { base } from 'viem/chains'
import { Config } from 'wagmi'

import { extendConfig } from '@eulerxyz/wagmi-evc'
import { createConfig } from '@privy-io/wagmi'
import { getChains } from './getChains'
import { getTransports } from './getTransports'
import { createWagmiStorage } from './storage'

export function getConfig(): Config {
  const baseDevNetChain = getBaseDevNetChain()
  const transports = getTransports({ baseDevNetChain })
  const chains = getChains({ baseDevNetChain })
  const storage = createWagmiStorage()

  const baseConfig = createConfig({
    chains,
    transports,
    storage,
    multiInjectedProviderDiscovery: false,
    ssr: true,
  })

  // Extend config with EVC functionality (getEvcClient, vault aggregators, etc.)
  // The extended config adds methods: getEvcClient, getVaultAggregator, getManagedVaultAggregator,
  // getAccountAggregator, getOracleBatchItemFactory, getPriceAggregator
  // Cast back to Config for compatibility with existing providers
  const config = extendConfig(baseConfig as Config)

  return config as unknown as Config
}

function getBaseDevNetChain(): Chain | undefined {
  if (typeof process.env.NEXT_PUBLIC_DEV_BASE_DEVNET_RPC_URL !== 'string') {
    return undefined
  }

  return {
    ...base,
    name: 'Base DevNet',
    rpcUrls: {
      public: { http: [process.env.NEXT_PUBLIC_DEV_BASE_DEVNET_RPC_URL] },
      default: { http: [process.env.NEXT_PUBLIC_DEV_BASE_DEVNET_RPC_URL] },
    },
  }
}
